module.exports = __webpack_public_path__ + "img/batch_edit_user_tags_csv.0e5d0213.png";